export default __webpack_public_path__ + "static/media/section1.d0b96d9d.png";